import {component} from '../form/Constant'

export const permissionOptionKeys = {
    basicInformation: 'basicInformation',
    dashboardManagement: 'dashboardManagement',
    conversation: 'conversation',
    pathwayManagement: 'pathwayManagement',
    hospitalManagement: 'hospitalManagement',
    patientManagement: 'patientManagement',
    reportManagement: 'reportManagement',
    hcpManagement: 'hcpManagement',
    supportTeamsManagement: 'supportTeamsManagement',
    generalPractitionerManagement: 'generalPractitionerManagement',
    selectAllOrOnly: 'selectAllOrOnly',

    name: 'name',
    description: 'description',

    selectAll: 'selectAll',

    allowToEdit: 'allowToEdit',
    allowToDelete: 'allowToDelete',
    allowToAdd: 'allowToAdd',
    allowToTransfer: 'allowToTransfer',
    allowToGroup: 'allowToGroup',
    allowToChangeLayout: 'allowToChangeLayout',
    allowToCreateConversation: 'allowToCreateConversation',
    allowToViewMessages: 'allowToViewMessages',
    allowToReplyMessages: 'allowToReplyMessages',
    allowToReceiveNotifications: 'allowToReceiveNotifications',
    qualified: 'qualified',
    active: 'active',

    //Permission with patient
    allowToAssignPathway: 'allowToAssignPathway',
    allowToAssignHcp: 'allowToAssignHcp',
    allowToAssignStaticList: 'allowToAssignStaticList',

    allowToViewPatientInfo: 'allowToViewPatientInfo',
    allowToViewPatientPortalConfig: 'allowToViewPatientPortalConfig',
    allowToEditPatientPortalConfig: 'allowToEditPatientPortalConfig',
    allowToViewSummary: 'allowToViewSummary',
    allowToViewObservations: 'allowToViewObservations',
    allowToAddObservations: 'allowToAddObservations',
    allowToViewParameters: 'allowToViewParameters',
    allowToAddParameters: 'allowToAddParameters',
    allowToViewActivities: 'allowToViewActivities',
    allowToAddBiometrics: 'allowToAddBiometrics',
    allowToViewSymptoms: 'allowToViewSymptoms',
    allowToViewReminders: 'allowToViewReminders',
    allowToAddReminders: 'allowToAddReminders',
    allowToViewNotes: 'allowToViewNotes',
    allowToAddNotes: 'allowToAddNotes',
    allowToViewExaminations: 'allowToViewExaminations',
    allowToAddExaminations: 'allowToAddExaminations',
    allowToViewRelevantContacts: 'allowToViewRelevantContacts',
    allowToAddRelevantContacts: 'allowToAddRelevantContacts',
    allowToViewDischargeInfo: 'allowToViewDischargeInfo',
    allowToDischargePatient: 'allowToDischargePatient',
    allowToViewWatchConfig: 'allowToViewWatchConfig',
    allowToUpdateWatchConfig: 'allowToUpdateWatchConfig',

    //Permission with hcp
    allowToViewHcpInfo: 'allowToViewHcpInfo',
    allowToViewHcpRole: 'allowToViewHcpRole',
    allowToAssignHcpRole: 'allowToAssignHcpRole',
    allowToDeleteHcpRole: 'allowToDeleteHcpRole',
    allowToViewHcpPatient: 'allowToViewHcpPatient',
    allowToAssignNewHcpPatient: 'allowToAssignNewHcpPatient',
    allowToRemoveHcpPatient: 'allowToRemoveHcpPatient',
    allowToViewHcpStaticList: 'allowToViewHcpStaticList',
    allowToAddNewHcpStaticList: 'allowToAddNewHcpStaticList',
    allowToRemoveHcpStaticList: 'allowToRemoveHcpStaticList',
    allowToViewHcpSupportTeams: 'allowToViewHcpSupportTeams',
}

export const roleList = [
    {
        key: permissionOptionKeys.hospitalManagement,
        label: 'Hospital Management',
        description: '',
        children: [
            {
                key: permissionOptionKeys.allowToAdd,
                parentKey: permissionOptionKeys.hospitalManagement,
                component: component.checkbox,
                className: 'mr-3 p-2',
            },
            {
                key: permissionOptionKeys.allowToEdit,
                parentKey: permissionOptionKeys.hospitalManagement,
                component: component.checkbox,
                className: 'mr-3 p-2',
            },
        ],
    },
    {
        key: permissionOptionKeys.hcpManagement,
        label: 'HCP Management',
        description: '',
        children: [
            {
                key: permissionOptionKeys.allowToAdd,
                parentKey: permissionOptionKeys.hcpManagement,
                component: component.checkbox,
                className: 'mr-3 p-2',
            },
            {
                key: permissionOptionKeys.allowToEdit,
                parentKey: permissionOptionKeys.hcpManagement,
                component: component.checkbox,
                className: 'mr-3 p-2',
            },
            {
                key: permissionOptionKeys.allowToTransfer,
                parentKey: permissionOptionKeys.hcpManagement,
                component: component.checkbox,
                className: 'mr-3 p-2',
            },
            {
                key: permissionOptionKeys.allowToViewHcpInfo,
                parentKey: permissionOptionKeys.hcpManagement,
                component: component.checkbox,
                className: 'mr-3 p-2',
            },
            {
                key: permissionOptionKeys.allowToViewHcpRole,
                parentKey: permissionOptionKeys.hcpManagement,
                component: component.checkbox,
                className: 'mr-3 p-2',
            },
            {
                key: permissionOptionKeys.allowToAssignHcpRole,
                parentKey: permissionOptionKeys.hcpManagement,
                component: component.checkbox,
                className: 'mr-3 p-2',
            },
            {
                key: permissionOptionKeys.allowToDeleteHcpRole,
                parentKey: permissionOptionKeys.hcpManagement,
                component: component.checkbox,
                className: 'mr-3 p-2',
            },
            {
                key: permissionOptionKeys.allowToViewHcpPatient,
                parentKey: permissionOptionKeys.hcpManagement,
                component: component.checkbox,
                className: 'mr-3 p-2',
            },
            {
                key: permissionOptionKeys.allowToAssignNewHcpPatient,
                parentKey: permissionOptionKeys.hcpManagement,
                component: component.checkbox,
                className: 'mr-3 p-2',
            },
            {
                key: permissionOptionKeys.allowToRemoveHcpPatient,
                parentKey: permissionOptionKeys.hcpManagement,
                component: component.checkbox,
                className: 'mr-3 p-2',
            },
            {
                key: permissionOptionKeys.allowToViewHcpStaticList,
                parentKey: permissionOptionKeys.hcpManagement,
                component: component.checkbox,
                className: 'mr-3 p-2',
            },
            {
                key: permissionOptionKeys.allowToAddNewHcpStaticList,
                parentKey: permissionOptionKeys.hcpManagement,
                component: component.checkbox,
                className: 'mr-3 p-2',
            },
            {
                key: permissionOptionKeys.allowToRemoveHcpStaticList,
                parentKey: permissionOptionKeys.hcpManagement,
                component: component.checkbox,
                className: 'mr-3 p-2',
            },
            {
                key: permissionOptionKeys.allowToViewHcpSupportTeams,
                parentKey: permissionOptionKeys.hcpManagement,
                component: component.checkbox,
                className: 'mr-3 p-2',
            },
        ],
    },
    {
        key: permissionOptionKeys.patientManagement,
        description: '',
        children: [
            {
                key: permissionOptionKeys.allowToAdd,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToEdit,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToAssignHcp,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToAssignPathway,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToAssignStaticList,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToViewPatientInfo,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToViewPatientPortalConfig,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToEditPatientPortalConfig,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToViewObservations,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToViewSummary,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToAddObservations,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToViewParameters,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToAddParameters,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToViewActivities,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToAddBiometrics,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToViewSymptoms,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToViewReminders,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToAddReminders,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToViewNotes,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToAddNotes,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToViewExaminations,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToAddExaminations,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToViewRelevantContacts,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToAddRelevantContacts,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToViewDischargeInfo,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToDischargePatient,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToViewWatchConfig,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToUpdateWatchConfig,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
            {
                key: permissionOptionKeys.qualified,
                parentKey: permissionOptionKeys.patientManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
        ],
    },
    {
        key: permissionOptionKeys.pathwayManagement,
        description: '',
        children: [
            {
                key: permissionOptionKeys.allowToAdd,
                parentKey: permissionOptionKeys.pathwayManagement,
                component: component.checkbox,
                className: 'col-4 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToEdit,
                parentKey: permissionOptionKeys.pathwayManagement,
                component: component.checkbox,
                className: 'col-4 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToDelete,
                parentKey: permissionOptionKeys.pathwayManagement,
                component: component.checkbox,
                className: 'col-4 m-0 p-1',
            },
        ],
    },
    {
        key: permissionOptionKeys.supportTeamsManagement,
        description: '',
        children: [
            {
                key: permissionOptionKeys.allowToAdd,
                parentKey: permissionOptionKeys.supportTeamsManagement,
                component: component.checkbox,
                className: 'col-4 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToEdit,
                parentKey: permissionOptionKeys.supportTeamsManagement,
                component: component.checkbox,
                className: 'col-4 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToDelete,
                parentKey: permissionOptionKeys.supportTeamsManagement,
                component: component.checkbox,
                className: 'col-6 m-0 p-1',
            },
        ],
    },
    {
        key: permissionOptionKeys.generalPractitionerManagement,
        description: '',
        children: [
            {
                key: permissionOptionKeys.allowToAdd,
                parentKey: permissionOptionKeys.generalPractitionerManagement,
                component: component.checkbox,
                className: 'col-4 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToEdit,
                parentKey: permissionOptionKeys.generalPractitionerManagement,
                component: component.checkbox,
                className: 'col-4 m-0 p-1',
            },
            {
                key: permissionOptionKeys.allowToDelete,
                parentKey: permissionOptionKeys.generalPractitionerManagement,
                component: component.checkbox,
                className: 'col-4 m-0 p-1',
            },
        ],
    },
]
